import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import { useImageStatus } from '../hooks/use-image-status';
import { AvatarInitials } from './avatar-initials';

interface AvatarImageProps {
	name?: string;
	src?: string;
}

const AvatarImage: FC<AvatarImageProps> = ({ name, src }) => {
	const { isLoaded } = useImageStatus(src);
	const showInitials = !src || !isLoaded;

	if (showInitials) {
		return <AvatarInitials name={name} />;
	}

	return <Box alt={name} as="img" h="full" w="full" objectFit="cover" src={src} />;
};

AvatarImage.displayName = 'AvatarImage';

export { AvatarImage };
